import { Pipe, PipeTransform } from '@angular/core';

import { isUserAdmin } from 'src/app/user/constants/constants';

@Pipe({ name: 'isUserAdmin', standalone: true })
export class IsUserAdminPipe implements PipeTransform {
  transform(userData: any): boolean {
    return isUserAdmin(userData);
  }
}
